import type { JSX } from 'react';

/**
 * How far through a course somebody is.
 *
 * One component for all three places that ask — the pupil's list, the pupil's course page, and the
 * teacher's roll — because they were copies of the same bar drifting apart: two rounded the
 * percentage, one did not, and only one of them said "Пройден" at the end.
 *
 * The bar is never empty. A two-percent sliver at nought reads as "not started"; a track with
 * nothing in it reads as broken.
 */
export function Progress({
  percent,
  compact,
}: {
  percent: number;
  /** Inline in a dense list, where the bar has to give way to the words around it. */
  compact?: boolean;
}): JSX.Element {
  const done = percent >= 100;
  const rounded = Math.round(percent);

  return (
    <div className={`progress${compact ? ' progress--compact' : ''}`}>
      <div className="progress__track">
        <div
          className={`progress__fill${done ? ' progress__fill--done' : ''}`}
          style={{ width: `${Math.max(rounded, 2)}%` }}
        />
      </div>
      {/*
       * The number is the point, so it is never abbreviated away — "Пройден" replaces it only at a
       * hundred, where the number no longer tells you anything the word does not.
       */}
      <span className={`progress__value${done ? ' progress__value--done' : ''}`}>
        {done ? 'Пройден' : `${rounded}%`}
      </span>
    </div>
  );
}
